import { jsx as _jsx } from "react/jsx-runtime";
import { useTheme } from '@material-ui/core/styles';
import { CircularProgress } from '@material-ui/core';
export function MCircularProgress({ color = 'primary', sx, ...other }) {
    const theme = useTheme();
    if (color === 'inherit' || color === 'primary' || color === 'secondary') {
        return _jsx(CircularProgress, Object.assign({ color: color, sx: sx }, other), void 0);
    }
    return (_jsx(CircularProgress, Object.assign({ sx: {
            color: theme.palette[color].main,
            ...sx,
        } }, other), void 0));
}
//# sourceMappingURL=MCircularProgress.js.map